const theme = {
  '--gray-color': '#E8F5E9',
  '--orange-color': '#084f0b',
  '--orange-hover-color': '#2E7D32',
  '--orange-datepicker-selection-color': '#66BB6A',
  '--blue-color': '#388E3C',
  '--white-color': '#FFFFFF',
  '--black-color': '#000000',
  '--navtext-color': '#FFFFFF',
  '--header-color': '#2E7D32',
};

export default theme;